import React from 'react';

import { IInner, IOuter } from './FileIcon.types';
import { MediaType } from '../../../constants/MediaType';
import { isFolder } from '../../../utils/media-manager-sdk/items';
import * as FileIcons from './icons';
import * as OldIcons from './icons/old';

const selectItemIcon = (item) => {
  const iconSet = window.isNewColorsBrandingEnabled ? FileIcons : OldIcons;
  if (isFolder(item)) {
    return iconSet.Folder;
  }

  switch (item.mediaType) {
    case MediaType.SecurePicture:
    case MediaType.Picture:
    case MediaType.VectorArt:
      return iconSet.Picture;

    case MediaType.SecureVideo:
    case MediaType.Video:
      return iconSet.Video;

    case MediaType.SecureMusic:
    case MediaType.Music:
      return iconSet.Music;

    case MediaType.SecureDocument:
    case MediaType.Document:
    case MediaType.SWF:
      return iconSet.Document;

    case MediaType.SecureZip:
    case MediaType.Zip:
      return iconSet.Zip;

    default:
      return '';
  }
};

export const FileIconComponent: React.FC<IOuter & IInner> = ({ item }) => <img src={selectItemIcon(item)} />;
